import { Controller } from "@hotwired/stimulus"

// Clicks the "load more" link when the sentinel scrolls near the viewport,
// turning the Turbo Stream link into Hotwire infinite scroll. rootMargin
// pre-loads a bit early so the next page is ready before the user hits bottom.
export default class extends Controller {
  static targets = ["trigger"]

  connect() {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) this.triggerTarget.click()
      },
      { rootMargin: "300px" }
    )
    this.observer.observe(this.triggerTarget)
  }

  disconnect() {
    this.observer?.disconnect()
  }
}
